// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f754fd7e/" + chunkId + "." + __webpack_require__.h() + ".vf754fd7e.js";
};